module.exports = __webpack_public_path__ + "img/Mitsubishi_Electric_logo.svg.735ebca6.png";